export type ConsumableMovementType = 'restock' | 'consume' | 'adjust'

export const CONSUMABLE_CATEGORIES = ['upland', 'feed', 'ammo', 'other'] as const

export type ConsumableCategory = (typeof CONSUMABLE_CATEGORIES)[number]

export const CONSUMABLE_CATEGORY_LABELS: Record<ConsumableCategory, string> = {
  upland: 'Upland birds',
  feed: 'Feed',
  ammo: 'Ammo',
  other: 'Other',
}

export type Consumable = {
  id: string
  orgId: string
  name: string
  unit: string
  category: ConsumableCategory
  speciesId?: string
  speciesName?: string
  rateId?: string
  rateName?: string
  rateAmount?: number
  bookable: boolean
  countsAgainstInventory: boolean
  lowStockThreshold?: number
  notes?: string
  stock?: number
  lowStock?: boolean
  committed?: number
  createdBy?: string
  createdAt: string
  updatedAt: string
}

export type ConsumableMovement = {
  id: string
  consumableId: string
  orgId: string
  movementType: ConsumableMovementType
  quantity: number
  note?: string
  expenseId?: string
  sourceType?: string
  sourceId?: string
  occurredAt: string
  createdBy?: string
  createdByName?: string
  createdAt: string
}

export type BookableConsumable = {
  id: string
  name: string
  unit: string
  speciesId?: string
  speciesName?: string
  countsAgainstInventory: boolean
  rateAmount?: number
  available?: number
  pending?: number
  remaining?: number
}

export function hasStockToBook(consumable: BookableConsumable): boolean {
  if (!consumable.countsAgainstInventory) return true
  const remaining = consumable.remaining ?? consumable.available
  return remaining === undefined || remaining > 0
}

export type LinkableRate = {
  id: string
  name: string
  amount: number
  denomination: string
  linkedConsumableId?: string
  linkedConsumableName?: string
}
